import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { CONTROL_ACTIONMODE } from '../../Constants';

/**
 * 敷地を座標入力して作成するためのダイアログ
 */
class SiteCoordinateinputDialog extends Dialog {
    _itemSite: marietta.webcad.item.Site;

    get itemSite(): marietta.webcad.item.Site {
      return this._itemSite;
    }

    set itemSite(item: marietta.webcad.item.Site) {
      this._itemSite = item;
    }

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);

      // ダイアログのコンテンツ生成
      const id = 'siteCoordinateinputDialog';
      let title = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': title = '座標入力'; break;
        default: title = 'Site Coordinate Input'; break;
      }
      let contents = '<div class ="headerBox"><button id="addNewRow">+</button><button id="removeRow">-</button></div>';
      contents += '<div class="p-webcadControlDescriptionBox siteCoordinateinputDialog_contentBox">';
      contents += '<table id="dotInputTable">';
      contents += '<tbody>';
      contents += '<tr><th class = "rowCount">No</th><th>x座標</th><th>y座標</th></tr>';
      contents += '</tbody>';
      contents += '</table>';
      contents += '</div>';
      let footer = '<p id="errorMessage"> </p>';
      footer += '<div id="footButtons"><button id="btnDotInputPreview"><span class="jp">プレビュー</span><span class="en">Preview</span></button>';
      footer += '<button id="btnDotInputOk"><span class="jp">OK</span><span class="en">OK</span></button>';
      footer += '<button id="btnDotInputCancel" ><span class="jp">キャンセル</span><span class="en">Close</span></button></div>';

      this.createDialog(id, title, contents, footer);

      for (let i = 0; i < 3; i += 1) {
        this.addPointInput();
      }

      document.getElementById('addNewRow').addEventListener('click', () => {
        this.addPointInput();
      });

      document.getElementById('removeRow').addEventListener('click', () => {
        this.deletePointInput();
      });

      document.getElementById('modalBg').classList.add('forSiteDotInputDialog');

      document.getElementById('btnDotInputOk').addEventListener('click', () => {
        if (this.itemSite) {
          const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1).layer_site as marietta.webcad.layer.SiteLayer;
          const siteItems = tarLayer.getAllChildren();
          if (siteItems.length > 0) {
            (siteItems[siteItems.length - 1] as marietta.webcad.item.Site).deleteMe();
          }
        }
        this.createSiteWithPoints(false);
      });

      document.getElementById('btnDotInputPreview').addEventListener('click', () => {
        if (this.itemSite) {
          const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1).layer_site as marietta.webcad.layer.SiteLayer;
          const siteItems = tarLayer.getAllChildren();
          if (siteItems.length > 0) {
            (siteItems[siteItems.length - 1] as marietta.webcad.item.Site).deleteMe();
          }
          this.itemSite = null;
        }
        this.createSiteWithPoints(true);
      });

      document.getElementById('btnDotInputCancel').addEventListener('click', () => {
        this.close();
      });

      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
    }

    setInputFilter= (textbox, inputFilter) => {
      ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach((event) => {
        for (let i = 0; i < textbox.length; i += 1) {
          (<HTMLInputElement>textbox[i]).addEventListener(event, function () {
            if (inputFilter(this.value)) {
              this.oldValue = this.value;
              this.oldSelectionStart = this.selectionStart;
              this.oldSelectionEnd = this.selectionEnd;
            // eslint-disable-next-line no-prototype-builtins
            } else if (this.hasOwnProperty('oldValue')) {
              this.value = this.oldValue;
              this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
          });
        }
      });
    }

    addPointInput() {
      const table: any = document.getElementById('dotInputTable');
      const rowCount: number = table.rows.length;
      const row = table.insertRow(rowCount);
      const cell1 = row.insertCell(0);
      const cell2 = row.insertCell(1);
      const cell3 = row.insertCell(2);
      cell1.className = 'rowCount';
      cell1.innerHTML = rowCount;
      cell2.innerHTML = `<input maxlength='13' id='xCoord_${rowCount}' value='0' type='text' class='inpXCoord coordinates'/><span>mm</span>`;
      cell3.innerHTML = `<input maxlength='13' id='yCoord_${rowCount}' value='0' type='text' class='inpYCoord coordinates'/><span>mm</span>`;
      if (rowCount > 3) {
        (<HTMLInputElement>document.getElementById('removeRow')).disabled = false;
      } else {
        (<HTMLInputElement>document.getElementById('removeRow')).disabled = true;
      }
      this.setInputFilter(document.getElementsByClassName('coordinates'), (value) => /^-?\d*[.,]?\d*$/.test(value));
    }

    deletePointInput = () => {
      const table: any = document.getElementById('dotInputTable');
      const rowCount = table.rows.length;
      if (rowCount > 4) table.deleteRow(rowCount - 1);
      if (rowCount - 1 === 4) {
        (<HTMLInputElement>document.getElementById('removeRow')).disabled = true;
      }
    }

    createSiteWithPoints(isPreview: boolean = false) {
      document.getElementById('errorMessage').textContent = '';
      const dotList: any = [];
      const table: any = document.getElementById('dotInputTable');
      const rowCount = table.rows.length;
      for (let i = 1; i < rowCount; i += 1) {
        if (Number.isNaN(parseFloat((<HTMLInputElement>document.getElementById(`xCoord_${i}`)).value)) || Number.isNaN(parseFloat((<HTMLInputElement>document.getElementById(`yCoord_${i}`)).value))) {
          document.getElementById('errorMessage').textContent = '数値を入力してください';
          return;
        }
      }
      const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
      const centerPoint: marietta.core.Point = marietta.webcad.util.WebCADUtil.getPointStageCenter();
      let dot: marietta.webcad.collection.PointCollection;
      const snapUnit = marietta.webcad.WebCADGlobal.PIX_IN_GRID * marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit;

      info.x = (centerPoint.x / snapUnit) * snapUnit;
      info.y = (centerPoint.y / snapUnit) * snapUnit;
      info.id = 'sit01_01';
      info.guid = marietta.webcad.WebCADGlobal.getGuid();
      info.dotList = [];

      if (rowCount < 4) {
        document.getElementById('errorMessage').textContent = '３点以上入力してください。';
        return;
      }
      let coords: any;
      let minX: number = Number.isNaN((parseFloat((<HTMLInputElement>document.getElementById(`xCoord_${1}`)).value))) ? 0 : parseFloat((<HTMLInputElement>document.getElementById(`xCoord_${1}`)).value);
      let maxX: number = Number.isNaN((parseFloat((<HTMLInputElement>document.getElementById(`xCoord_${1}`)).value))) ? 0 : parseFloat((<HTMLInputElement>document.getElementById(`xCoord_${1}`)).value);
      let minY: number = Number.isNaN((parseFloat((<HTMLInputElement>document.getElementById(`yCoord_${1}`)).value))) ? 0 : parseFloat((<HTMLInputElement>document.getElementById(`yCoord_${1}`)).value);
      let maxY: number = Number.isNaN((parseFloat((<HTMLInputElement>document.getElementById(`yCoord_${1}`)).value))) ? 0 : parseFloat((<HTMLInputElement>document.getElementById(`yCoord_${1}`)).value);

      for (let i = 1; i < rowCount; i += 1) {
        coords = {};
        coords.x = parseFloat((<HTMLInputElement>document.getElementById(`xCoord_${i}`)).value);
        coords.x = (Number.isNaN(coords.x) ? 0 : coords.x);
        coords.y = parseFloat((<HTMLInputElement>document.getElementById(`yCoord_${i}`)).value);
        coords.y = (Number.isNaN(coords.y) ? 0 : coords.y);
        if (coords.x < minX) minX = coords.x;
        if (maxX < coords.x) maxX = coords.x;
        if (coords.y < minY) minY = coords.y;
        if (maxY < coords.y) maxY = coords.y;
        const p1 = marietta.webcad.util.WebCADUtil.convertMMToPix(coords.x) + info.x;
        const p2 = (marietta.webcad.util.WebCADUtil.convertMMToPix(coords.y) + info.y) * -1;
        dotList.push(new marietta.core.Point(p1, p2));
      }

      const area = marietta.webcad.util.WebCADUtil.calculateArea(dotList);
      if (area < 1) {
        document.getElementById('errorMessage').textContent = '敷地座標を再度確認し、入力してください。';
        return;
      }

      if (maxX - minX > 100000) {
        document.getElementById('errorMessage').textContent = '敷地の最大幅は100mです。';
        return;
      }
      if (maxY - minY > 100000) {
        document.getElementById('errorMessage').textContent = '敷地の最大高さは100mです。';
        return;
      }

      const { x } = dotList[0];
      const { y } = dotList[0];
      for (let j: number = 0; j < dotList.length; j += 1) {
        dot = new marietta.webcad.collection.PointCollection(dotList[j].x - x, dotList[j].y - y);
        dot.guid = marietta.webcad.WebCADGlobal.getGuid();
        info.dotList.push(dot);
      }
      marietta.webcad.WebCADGlobal.itemManager.createItem(info);
      if (isPreview) {
        this.itemSite = marietta.webcad.WebCADGlobal.itemManager.lastCreatedItem as marietta.webcad.item.Site;
        marietta.webcad.WebCADGlobal.itemManager.itemController = new marietta.webcad.control.ItemControllerSite(this.itemSite as marietta.webcad.item.Site);
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
      } else {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE;
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
        document.getElementById('modalBg').classList.remove('forSiteDotInputDialog');
        marietta.webcad.WebCADGlobal.removeDialog();
      }
    }

    /**
     * 閉じるボタンが押された
     */
    close = () => {
      document.getElementById('modalBg').classList.remove('forSiteDotInputDialog');
      if (this.itemSite) {
        const tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1).layer_site as marietta.webcad.layer.SiteLayer;
        const siteItems = tarLayer.getAllChildren();
        if (siteItems.length > 0) {
          (siteItems[siteItems.length - 1] as marietta.webcad.item.Site).deleteMe();
        }
        this.itemSite = null;
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE;
      this.closeEvent();
    }
}
export default SiteCoordinateinputDialog;
